import { NextPage } from 'next';
import React from 'react';
import { FindSupplier } from '../../../components/FindSupplier';
import { LayoutEmbed } from '../../../components/LayoutEmbed';

const FindSupplierEmbedPage: NextPage & {
    LayoutComponent: React.ComponentType;
} = () => <FindSupplier />;

export default FindSupplierEmbedPage;

FindSupplierEmbedPage.LayoutComponent = LayoutEmbed;
